export default [
    {
        label: 'Education Level',
        value: 'prefered_education_levels',
        options: [{ value: 'Master', label: 'Master' }, { value: 'Bachelor', label: 'Bachelor' }],
    },
    {
        label: 'Country/Region',
        value: 'country_region',
        options: [],
    },
    {
        label: 'Sectors',
        value: 'sectors',
        options: [],
    },
    {
        label: 'Languages',
        value: 'languages',
        options: [],
    },
    {
        label: 'Position types',
        value: 'position_types',
        options: [],
    },
];

export const postingFilterLabels = {
    prefered_education_levels: 'Education Level',

    country: 'Country',
    tags: 'Sectors',
    prefered_languages: 'Languages',
    position_types: 'Position types',
    job_type: 'Job Type',
};
